import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { useSiteMetadataDifferentLang } from "@hooks/siteURLs"

const isBrowser = typeof window !== "undefined"

const SEO = ({ pageContext, html = null, outsideCookiesPolicy = false }) => {
  const { t } = useTranslation()

  let meta = useSiteMetadataDifferentLang(
    pageContext.slug,
    pageContext.availableLanguages
  )
  let slug = pageContext.slug

  if (pageContext.slug === "") slug = "home"

  const bLoadCookiesPolicy =
    outsideCookiesPolicy === undefined || outsideCookiesPolicy === false

  function cleanCanonicalURL(url) {
    if (!url) return null
    if (url.endsWith("/de/") || url.endsWith("/en/") || url.endsWith("/")) {
      return url.slice(0, -1)
    }
    return url
  }

  useEffect(() => {
    if (
      isBrowser &&
      typeof window.UC_UI !== "undefined" &&
      window.UC_UI.isInitialized()
    ) {
      window.UC_UI.updateLanguage(pageContext.language)
    }
  }, [pageContext.language])

  return (
    <Helmet
      htmlAttributes={{
        lang: pageContext.language || "en",
      }}
    >
      <title>{html?.title ? html?.title : t(`seo:${slug}_title`)}</title>
      <meta
        name="google-site-verification"
        content="6KjiR1ccDL08mGUTxEgJAHORyv2hDsuv_G4fV8EmGZ8"
      />
      <meta
        name="description"
        content={
          html?.description ? html?.description : t(`seo:${slug}_description`)
        }
      />
      <meta name="keywords" content={t(`seo:${slug}_keywords`)} />
      <link
        rel="canonical"
        href={`https://www.metaloop.com${cleanCanonicalURL(
          meta.url[pageContext.language]
        )}/`}
      />
      {Object.keys(meta.url).map(url => (
        <link
          rel="alternate"
          key={url}
          hreflang={`${url}`}
          href={`https://www.metaloop.com${cleanCanonicalURL(meta.url[url])}/`}
        />
      ))}
      <link
        rel="alternate"
        href={`https://www.metaloop.com${cleanCanonicalURL(
          meta.url[pageContext.language]
        )}/`}
        hreflang="x-default"
      />

      {isBrowser && bLoadCookiesPolicy && (
        <script
          id="usercentrics-cmp"
          src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
          data-settings-id="2vMDgJpPl"
          data-language={pageContext.language || "en"}
          async
          defer
        ></script>
      )}
      {isBrowser && (
        <script
          type="text/javascript"
          src="https://www.innovative-astute.com/js/798238.js"
        ></script>
      )}

      <script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js-eu1.hs-scripts.com/25964422.js"
      ></script>

      {/* New tracking script (Leadfeeder) */}
      <script>
        {`(function(ss,ex){
          window.ldfdr=window.ldfdr||function(){
            (ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));
          };
          (function(d,s){
            fs=d.getElementsByTagName(s)[0];
            function ce(src){
              var cs=d.createElement(s);
              cs.src=src;
              cs.async=1;
              fs.parentNode.insertBefore(cs,fs);
            };
            ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js');
          })(document,'script');
        })('kn9Eq4RqyEj7RlvP');`}
      </script>
    </Helmet>
  )
}

export default SEO
